/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Retention_3Inputs */

const da_privacy_retention_3 = /** @type {(inputs: Privacy_Retention_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log over logins og brug: 12 måneder.`)
};

/** @type {(inputs: Privacy_Retention_3Inputs) => LocalizedString} */
const en_privacy_retention_3 = da_privacy_retention_3;

/**

* @param {Privacy_Retention_3Inputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const privacy_retention_3 = /** @type {((inputs?: Privacy_Retention_3Inputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Retention_3Inputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacy_retention_3(inputs)
	return /** @type {LocalizedString} */ ("Log over logins og brug: 12 måneder.")
});